import React from 'react'
import styles from './s.module.css'

class PipeFilling extends React.Component {
  render () {
    const svgFill = this.props.percent * 0.01
    let fillColor, text
    if (svgFill >= this.props.max) {
      fillColor = 'red'
      text = null
    } else {
      fillColor = '#9dd6f2'
      text = svgFill === 0
        ? null
        : <text x='50' y='50' dy='8' textAnchor='middle' fontSize='30' >{this.props.displayValue}</text>
    }
    return (
      <div className={styles.dimItemContainer}>
        <label>{this.props.label}</label>
        <svg width='100' height='100' >
          <defs>
            <linearGradient id='grad1' x1='100%' y1='100%' x2='100%' y2='0%'>
              <stop stopColor={fillColor} offset={svgFill} />
              <stop stopColor={'#fff'} offset={svgFill} />
            </linearGradient>
          </defs>
          <circle cx='50' cy='50' r='45' stroke='black' strokeWidth='4' fill='url(#grad1)' />
          {text}
        </svg>
      </div>
    )
  }
}

// PipeFilling.propTypes = {
//   label: PropTypes.string,
//   percent: PropTypes.number,
//   displayValue: PropTypes.number,
//   max: PropTypes.number
// }

export default PipeFilling
